import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import type { UserMenuSubject } from './types';

interface UserMenuUserCardProps {
  user: UserMenuSubject;
  email?: string | undefined;
}

/** Names the person signed in, as opposed to the company they are acting for. */
export function UserMenuUserCard({ user, email }: UserMenuUserCardProps) {
  return (
    <div className='px-3 py-2.5 bg-muted/30'>
      <div className='flex items-center gap-2.5'>
        <Avatar className='h-7 w-7 shrink-0'>
          <AvatarImage src={user.imageUrl} alt={user.name} />
          <AvatarFallback
            delay={0}
            className='bg-primary text-primary-foreground text-xs font-semibold'
          >
            {user.initials}
          </AvatarFallback>
        </Avatar>
        <div className='min-w-0'>
          <p className='text-xs font-semibold truncate'>{user.name}</p>
          <p className='text-xs text-muted-foreground truncate'>{email}</p>
        </div>
      </div>
    </div>
  );
}
